import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";

import Home from "./pages/Home";
import Layout from "./components/Layout";
import Shop from "./pages/Shop";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import MyOrders from "./pages/MyOrders";
import OrderTracking from "./pages/OrderTracking";
import AccountSettings from "./pages/AccountSettings";
import PaymentMethods from "./pages/PaymentMethods";
import AdminDashboard from "./pages/AdminDashboard";
import AdminOrders from "./pages/AdminOrders";
import AdminOrderDetail from "./pages/AdminOrderDetail";
import AdminProducts from "./pages/AdminProducts";
import AdminUsers from "./pages/AdminUsers";
import AdminPayments from "./pages/AdminPayments";
import { cartApi } from "./api/cartApi";
import { authApi } from "./api/authApi";

function App() {
  const [cartCount, setCartCount] = useState(0);
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetchUser();
    fetchCartCount();
  }, []);

  const fetchUser = async () => {
    try {
      const response = await authApi.me();
      setUser(response.user);
    } catch (error) {
      // User not logged in, that's fine
      setUser(null);
    }
  };

  const fetchCartCount = async () => {
    try {
      const response = await cartApi.getCart();
      // Sum all quantities instead of counting items
      const count = response.items 
        ? response.items.reduce((total, item) => total + item.quantity, 0)
        : 0;
      setCartCount(count);
    } catch (error) {
      console.error("Error fetching cart count:", error);
    }
  };

  const updateCartCount = (newCount) => {
    setCartCount(newCount);
  };

  const updateUser = (newUser) => {
    setUser(newUser);
    fetchCartCount();
  };

  return (
    <BrowserRouter>
      <Layout cartCount={cartCount} user={user} onCartUpdate={updateCartCount} onUserUpdate={updateUser}>
        <Routes>
          <Route path="/" element={<Home onCartUpdate={updateCartCount} />} />
          <Route path="/shop" element={<Shop onCartUpdate={updateCartCount} />} />
          <Route path="/login" element={<Login onUserUpdate={updateUser} />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/cart" element={<Cart user={user} onCartUpdate={updateCartCount} />} />
          <Route path="/checkout" element={<Checkout onCheckout={fetchCartCount} />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/order-tracking/:id" element={<OrderTracking />} />
          <Route path="/account-settings" element={<AccountSettings />} />
          <Route path="/payment-methods" element={<PaymentMethods />} />

          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/admin-orders" element={<AdminOrders />} />
          <Route path="/admin-order-detail/:id" element={<AdminOrderDetail />} />
          <Route path="/admin-products" element={<AdminProducts />} />
          <Route path="/admin-users" element={<AdminUsers />} />
          <Route path="/admin-payments" element={<AdminPayments />} />
          {/* Keep the payment admin page reachable from both route naming styles used in the project. */}
          <Route path="/admin/payments" element={<AdminPayments />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
